import React, { useCallback } from 'react';
import { route } from "~/app/helpers/route";
import { MachineOppgaver, MachineOppgaverIssue } from '~/types';
import classes from './style.module.scss';
import LinkWrapper from "~/app/common/LinkWrapper";
import { TASK_ROUTES } from '~/tasks/Router';
import useTranslation from '~/app/hooks/useTranslation';
import LightBoxImage from '~/app/common/LightBoxImage';
import Icon from '~/app/common/Icon';
import useAccessControl from '~/app/hooks/useAccessControl';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';

export interface ListItemProps {
  item: MachineOppgaver
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({ item }) => {

  const { t } = useTranslation('tasks.listing.taskTypes');

  const { checkPermission } = useAccessControl();
  const readServiceDetailsPermission = checkPermission(PERMISSION_GROUPS.readServiceDetails);

  const shouldShowTask = useCallback((task: MachineOppgaverIssue) => {
    if (task.type === 'service') {
      return readServiceDetailsPermission === true;
    }
    return true;
  }, [readServiceDetailsPermission]);

  const getTaskType = useCallback(() => {
    for (const task of item.tasks) {
      if (task.count > 0) {
        return task.type
      }
    }
    return '';
  }, [item.tasks]);

  return (
    <div className={classes['list-item']}>
      <div className={classes['category-image']}>
        <LightBoxImage image={item.image} />
      </div>
      <LinkWrapper className={classes['link-wrapper']} to={route(TASK_ROUTES.issue, { id: item.id })}>
        <div className={classes['info']}>
          <div className={classes['name']}>{item.name}</div>
          <div className={classes['code']}>ID: {item.intern}</div>
          <span className={`${classes['type']} ${classes[getTaskType()]}`}>
            <Icon name='warning' size={14}></Icon>
            {t(getTaskType())}
          </span>
          {item.tasks.map((task, index) => {
            const shouldShowDiv = shouldShowTask(task);
            return (
              shouldShowDiv && (
                <div key={index} className={classes['code']}>
                  {t(task.type)} : {task.count}
                </div>
              )
            );
          })}
        </div>
      </LinkWrapper>
    </div>
  );
};

export default ListItem
